if (!window.Eurus.loadedScript.includes('sealer-popup.js')) {
  window.Eurus.loadedScript.push('sealer-popup.js');
  document.addEventListener('alpine:init', () => {
    Alpine.data('sealerPopup', () => ({
      showPopup: false,
      loading: false,
      bundlePrice: '$0.00',
      bundleVariantId: null,
      popupHeading: 'Don\'t Forget to Protect Your Tiles!',
      bundleHandle: 'poseidons-tile-primer-and-zeus-tile-sealer', // default bundle
      bundleImage: null,
      bundleTitle: 'Poseidon\'s Tile Primer & Zeus Tile Sealer Bundle', // default title

      // New: Alternative bundle for terracotta (tag: 'terra')
      alternativeBundle: {
        handle: 'demeter-tile-primer-zeus-tile-sealer-bundle',
        title: 'Demeter’s Terracotta Tile Primer + Zeus’ Tile Sealer Bundle'
      },

      init() {
        document.addEventListener('box:added', (e) => {
          this.handleBoxAdded(e);
        });
      },

      async determineAndFetchBundle() {
        try {
          const response = await fetch('/cart.js');
          if (!response.ok) {
            await this.useDefaultBundle();
            return;
          }

          const cart = await response.json();

          // Only console log for cart items (as requested)
          //console.log('Current cart items:', cart.items);

          let hasTerraProduct = false;
          let hasZelligeProduct = false;
          let hasCementProduct = false;
          let hasNonZelligeProduct = false;

          cart.items.forEach((item) => {
            const productType = (item.product_type || '').toLowerCase();

            if (productType === 'terracotta tiles') {
              hasTerraProduct = true;
            }
            if (productType === 'zellige tile') {
              hasZelligeProduct = true;
            }
            if (productType === 'cement tiles') {
              hasCementProduct = true;
            }
            if (productType && productType !== 'zellige tile') {
              hasNonZelligeProduct = true;
            }
          });

          // Skip popup only if cart contains zellige and nothing else
          if (hasZelligeProduct && !hasNonZelligeProduct) {
            this.bundleVariantId = null;
            return;
          }

          // Set popup heading based on product types (terracotta takes priority)
          if (hasTerraProduct) {
            this.popupHeading = 'Don\'t Forget to Protect Your Terracotta Tiles!';
          } else if (hasCementProduct) {
            this.popupHeading = 'Don\'t Forget to Protect Your Cement Tiles!';
          } else {
            this.popupHeading = 'Don\'t Forget to Protect Your Tiles!';
          }

          if (hasTerraProduct) {
            this.bundleHandle = this.alternativeBundle.handle;
            this.bundleTitle = this.alternativeBundle.title;
          } else {
            this.bundleHandle = 'poseidons-tile-primer-and-zeus-tile-sealer';
            this.bundleTitle = 'Poseidon\'s Tile Primer & Zeus Tile Sealer Bundle';
          }

          await this.fetchBundleData();
        } catch (error) {
          await this.useDefaultBundle();
        }
      },

      async fetchBundleData() {
        try {
          const response = await fetch(`/products/${this.bundleHandle}.js`);
          if (response.ok) {
            const product = await response.json();
            if (product && product.variants && product.variants.length > 0) {
              this.bundleVariantId = product.variants[0].id;
              this.bundlePrice = this.formatPrice(product.variants[0].price);
              this.bundleTitle = product.title || this.bundleTitle; // Use actual title if different
              this.bundleImage = product.featured_image || (product.images && product.images[0]);
            } else {
              this.bundleVariantId = null;
            }
          } else {
            console.warn(`Bundle product not found for handle: ${this.bundleHandle}`);
            this.bundleVariantId = null;
          }
        } catch (error) {
          console.warn('Could not fetch bundle product data:', error);
          this.bundleVariantId = null;
        }
      },

      async handleBoxAdded(event) {
        // Re-check cart and load the correct bundle every time a box is added
        await this.determineAndFetchBundle();

        if (!this.bundleVariantId) {
          console.log('Sealer popup skipped: bundle product not available');
          return;
        }

        setTimeout(() => {
          this.showPopup = true;
        }, 1500);
      },

      async addToCart() {
        if (!this.bundleVariantId) {
          console.error('Bundle variant ID not available');
          return;
        }
        this.loading = true;
        try {
          const formData = new FormData();
          formData.append('id', this.bundleVariantId);
          formData.append('quantity', 1);

          if (Alpine.store('xCartHelper') && Alpine.store('xCartHelper').getSectionsToRender) {
            formData.append('sections', Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          }

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          if (response.ok) {
            const result = await response.json();

            // Your existing cart update logic
            if (result.sections && Alpine.store('xCartHelper') && Alpine.store('xCartHelper').getSectionsToRender) {
              Alpine.store('xCartHelper').getSectionsToRender().forEach((section) => {
                const sectionElement = document.querySelector(section.selector);
                if (sectionElement && result.sections[section.id] && typeof getSectionInnerHTML === 'function') {
                  sectionElement.innerHTML = getSectionInnerHTML(result.sections[section.id], section.selector);
                }
              });
            }

            // Update cart count, dispatch events, etc.
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: result }));
            document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));

            if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
              Alpine.store('xCartNoti').setItem(result);
            }

            this.closePopup();
          } else {
            console.error('Failed to add bundle to cart');
          }
        } catch (error) {
          console.error('Error adding bundle to cart:', error);
        } finally {
          this.loading = false;
        }
      },

      closePopup() {
        this.showPopup = false;
      },

      formatPrice(cents) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(cents / 100);
      }
    }));
  });
} 
